var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',_vm._l((_vm.table.cells),function(cell){return _c('require-permissions',{key:cell.label,attrs:{"all":cell.permissions}},[_c('header-cell',{attrs:{"cell":cell}},[_vm._v(_vm._s(cell.label))])],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }